module.exports = require( './svg-tags.json' );